import blogService from "../services/blogService";

// Upload qua axios instance chung để luôn gắn access token hiện tại (và tự refresh khi hết hạn),
// thay vì token đọc một lần lúc load module.
const uploadEditorImage = (file: Blob, fileName: string): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file, fileName);
  formData.append("fileCategory", "blog");
  return blogService.uploadImage(formData);
};

export const tinymceConfigForBlog = {
  height: 400,
  menubar: false,
  plugins: [
    "advlist",
    "autolink",
    "lists",
    "link",
    "image",
    "charmap",
    "preview",
    "anchor",
    "searchreplace",
    "visualblocks",
    "code",
    "fullscreen",
    "insertdatetime",
    "media",
    "table",
    "code",
    "help",
    "wordcount",
    "paste",
  ],
  toolbar:
    "undo redo | blocks | " +
    "bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter " +
    "alignright alignjustify | bullist numlist outdent indent | " +
    "removeformat | image | help",

  paste_data_images: false,
  automatic_uploads: true,
  file_picker_types: "image",
  images_upload_credentials: false,
  convert_urls: false,
  relative_urls: false,
  remove_script_host: false,

  branding: false,
  elementpath: false,
  resize: true,

  content_style:
    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",

  // TinyMCE 6+: handler trả về Promise<url>, không còn callback success/failure
  images_upload_handler: (blobInfo: any) =>
    uploadEditorImage(blobInfo.blob(), blobInfo.filename()).catch((error) => {
      console.error("Image upload error:", error);
      return Promise.reject({
        message: error ? `Upload ảnh thất bại: ${error}` : "Upload ảnh thất bại",
        remove: true,
      });
    }),

  setup: function (editor: any) {
    editor.on("init", function () {
      console.log("TinyMCE initialized");
    });

    editor.on("Paste", function (e: ClipboardEvent) {
      const clipboardItems = e.clipboardData?.items;
      if (!clipboardItems) return;

      for (const item of clipboardItems) {
        if (item.type.indexOf("image") !== -1) {
          const file = item.getAsFile();
          if (!file) return;

          uploadEditorImage(file, "clipboard.png")
            .then((fileUrl) => {
              if (fileUrl) {
                editor.insertContent(`<img src="${fileUrl}" />`);
              }
            })
            .catch((err) => {
              console.error("Clipboard upload failed:", err);
            });

          e.preventDefault();
          break;
        }
      }
    });
  },
};

export const tinymceConfigForJob = {
  height: 400,
  menubar: false,
  plugins: [
    "advlist",
    "autolink",
    "lists",
    "link",
    "image",
    "charmap",
    "preview",
    "anchor",
    "searchreplace",
    "visualblocks",
    "code",
    "fullscreen",
    "insertdatetime",
    "media",
    "table",
    "code",
    "help",
    "wordcount",
    "paste",
  ],
  toolbar:
    "undo redo | blocks | " +
    "bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter " +
    "alignright alignjustify",
  paste_data_images: false,
  automatic_uploads: false,
  file_picker_types: "image",
  images_upload_credentials: false,
  convert_urls: false,
  relative_urls: false,
  remove_script_host: false,

  branding: false,
  elementpath: false,
  resize: true,

  content_style:
    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",

  setup: function (editor: any) {
    editor.on("init", function () {
      console.log("TinyMCE initialized");
    });
  },
};
